import React from "react";
import { NavLink } from "react-router-dom";
import detailsClasses from "./details.module.scss";
import { BiTimeFive, BiPencil } from "react-icons/bi";
import { BsBook, BsPeople, BsGlobe, BsShieldCheck } from "react-icons/bs";
import { HiOutlinePlayCircle } from "react-icons/hi2";
import { RxPerson } from "react-icons/rx";
import { payment_props } from "./Types";
const PaymentDetails: React.FC<payment_props> = ({
    courseDetails,
    ActionBtn,
    btnName,
}) => {
    return (
        <div className={detailsClasses["right__side"]}>
            <h3> Course Details</h3>
            <div className={detailsClasses["payment_details"]}>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <BiTimeFive /> Course level
                    </h3>
                    <p
                        style={{
                            color: "#F19426",
                            fontWeight: "bold",
                        }}>
                        {courseDetails?.Level}
                    </p>
                </div>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <BsBook /> Classes Per Week
                    </h3>
                    <p>{courseDetails?.ClassPerWeek}</p>
                </div>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <BsPeople /> Age Group
                    </h3>
                    <p>
                        {courseDetails?.FromAge}-{courseDetails?.ToAge} Years
                    </p>
                </div>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <HiOutlinePlayCircle /> Total Sessions
                    </h3>
                    <p>{courseDetails?.NoOfSessions}</p>
                </div>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <RxPerson /> One-on-One
                    </h3>
                    <p>
                        {courseDetails?.One_One_Available === 1
                            ? "Available"
                            : "Not Available"}
                    </p>
                </div>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <BiPencil /> Writing Activity
                    </h3>
                    <p>{courseDetails?.WritingActivity}</p>
                </div>
                <div className={detailsClasses["detail"]}>
                    <h3>
                        <BsGlobe /> Language
                    </h3>
                    <p>{courseDetails?.Language}</p>
                </div>
                <div
                    className={`${detailsClasses["detail"]} ${detailsClasses["guarantee-detail"]}`}>
                    <h3>
                        <BsShieldCheck /> 6-Class Guarantee
                    </h3>
                    <p>
                        {courseDetails?.One_One_Available === 1
                            ? `Yes on One-to-One classes`
                            : "No"}
                    </p>
                </div>
                <div
                    className={`${detailsClasses["detail"]} ${detailsClasses["price-detail"]}`}
                    style={{ cursor: "pointer" }}>
                    <h3>Cost Per Class</h3>
                    <div className={detailsClasses["price"]}>
                        {courseDetails?.One_One_Available === 1 && (
                            <p>
                                One to One :
                                <span>
                                    {" "}
                                    &#8377; {courseDetails?.One_One_Price}
                                </span>
                            </p>
                        )}
                        {courseDetails?.IsGroupAvailable == 1 && (
                            <p>
                                Group Price :
                                <span>
                                    {" "}
                                    &#8377; {courseDetails?.Group_Price}
                                </span>
                            </p>
                        )}
                    </div>
                </div>
                <p className={detailsClasses["guarantee-note"]}>
                    Try 6 one-on-one classes, any time in your first 90
                    days. If it's not right for your child, we refund 100%
                    of what you paid — including the classes already
                    taken. For enrolments until 30 September 2026.{" "}
                    <NavLink to="/guarantee" target="_blank">Read full terms</NavLink>
                </p>
                <p className={detailsClasses["odd-hours-note"]}>
                    Odd hours charge disclosure — Classes booked between
                    10 PM–8 AM IST carry an extra charge (₹83.33/class).
                </p>
                {btnName && <button onClick={ActionBtn}>{btnName}</button>}
            </div>
        </div>
    );
};

export default PaymentDetails;
